import { render, staticRenderFns } from "./cpt-button.vue?vue&type=template&id=e1b221d8&scoped=true&"
import script from "./cpt-button.vue?vue&type=script&lang=js&"
export * from "./cpt-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b221d8",
  null
  
)

export default component.exports